import dip from "./slices/dip";
import debug from "./slices/debug";
import common from "./slices/common";
import dialog from "./slices/dialog";
import megaMenu from "./slices/mega-menu";
import webStore from "./slices/web-store";
import bundleUp from "./slices/bundle-up";
import waterfall from "./slices/waterfall";
import dailyGift from "./slices/daily-gift";
import stickyDip from "./slices/sticky-dip";
import shopSections from "./slices/shop-sections";
import poisBountyV3 from "./slices/pois-bounty-v3";
import popUpManager from "./slices/pop-up-manager";
import popUpManagerV2 from "./slices/pop-up-manager-v2";
import stickySaleTag from "./slices/sticky-sale-tag";
import pwa from "./slices/pwa";
import clubGiftsGalore from "./slices/club-gifts-galore";
import dailyLoginStreak from "./slices/daily-login-streak";
import signUpIncentive from "./slices/sign-up-incentive";
import inAppToWebDip from "./slices/in-app-to-web-dip";
import featuredDeals from "./slices/featured-deals";
import friendReferral from "./slices/friend-referral";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { baseApi } from "./apis/api";
import { devToolsConfig } from "./devToolsConfig";

const rootReducer = {
	webStore,
	dip,
	shopSections,
	poisBountyV3,
	megaMenu,
	dailyGift,
	stickyDip,
	waterfall,
	clubGiftsGalore,
	popUpManager,
	popUpManagerV2,
	dialog,
	dailyLoginStreak,
	stickySaleTag,
	signUpIncentive,
	inAppToWebDip,
	debug,
	common,
	bundleUp,
	featuredDeals,
	pwa,
	friendReferral,
	[baseApi.reducerPath]: baseApi.reducer
	//[segmentationOverrideApi.reducerPath]: segmentationOverrideApi.reducer
};

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				warnAfter: 128
			}
		}).concat([baseApi.middleware]),
	devTools: process.env.REACT_APP_WITH_DEBUG === "true" ? devToolsConfig : false
});

setupListeners(store.dispatch);
/***************************************************
 * Redux interfaces ~ types
 ***************************************************/
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
